const MapData = {
  maps: [
    {
      id: 9,
      name: "Arabia",
      image: "rm_arabia.png",
    },
    {
      id: 10,
      name: "Archipelago",
      image: "rm_archipelago.png",
    },
    {
      id: 11,
      name: "Baltic",
      image: "rm_baltic.png",
    },
    {
      id: 12,
      name: "Black Forest",
      image: "rm_black-forest.png",
    },
    {
      id: 13,
      name: "Coastal",
      image: "rm_coastal.png",
    },
    {
      id: 14,
      name: "Continental",
      image: "rm_continental.png",
    },
    {
      id: 15,
      name: "Crater Lake",
      image: "rm_crater-lake.png",
    },
    {
      id: 16,
      name: "Fortress",
      image: "rm_fortress.png",
    },
    {
      id: 17,
      name: "Gold Rush",
      image: "rm_gold-rush.png",
    },
    {
      id: 18,
      name: "Highland",
      image: "rm_highland.png",
    },
    {
      id: 19,
      name: "Islands",
      image: "rm_islands.png",
    },
    {
      id: 20,
      name: "Mediterranean",
      image: "rm_mediterranean.png",
    },
    {
      id: 21,
      name: "Migration",
      image: "rm_migration.png",
    },
    {
      id: 22,
      name: "Rivers",
      image: "rm_rivers.png",
    },
    {
      id: 23,
      name: "Team Islands",
      image: "rm_team-islands.png",
    },
    {
      id: 24,
      name: "Full Random",
      image: "rm_full-random.png",
    },
    {
      id: 25,
      name: "Scandinavia",
      image: "rm_scandinavia.png",
    },
    {
      id: 26,
      name: "Mongolia",
      image: "rm_mongolia.png",
    },
    {
      id: 27,
      name: "Yucatan",
      image: "rm_yucatan.png",
    },
    {
      id: 28,
      name: "Salt Marsh",
      image: "rm_salt-marsh.png",
    },
    {
      id: 29,
      name: "Arena",
      image: "rm_arena.png",
    },
    {
      id: 31,
      name: "Oasis",
      image: "rm_oasis.png",
    },
    {
      id: 32,
      name: "Ghost Lake",
      image: "rm_ghost-lake.png",
    },
    {
      id: 33,
      name: "Nomad",
      image: "rm_nomad.png",
    },
    {
      id: 49,
      name: "Iberia",
      image: "rwm_iberia.png",
    },
    {
      id: 50,
      name: "Britain",
      image: "rwm_britain.png",
    },
    {
      id: 51,
      name: "Mideast",
      image: "rwm_mideast.png",
    },
    {
      id: 52,
      name: "Texas",
      image: "rwm_texas.png",
    },
    {
      id: 53,
      name: "Italy",
      image: "rwm_italy.png",
    },
    {
      id: 54,
      name: "Central America",
      image: "rwm_central_america.png",
    },
    {
      id: 55,
      name: "France",
      image: "rwm_france.png",
    },
    {
      id: 56,
      name: "Norse Land",
      image: "rwm_norse_lands.png",
    },
    {
      id: 57,
      name: "Sea of Japan",
      image: "rwm_sea_of_japan.png",
    },
    {
      id: 58,
      name: "Byzantium",
      image: "rwm_byzantium.png",
    },
    {
      id: 59,
      name: "Generic",
      image: "cm_generic.png",
    },
    {
      id: 60,
      name: "Random Land Map",
      image: "rm_random_land_map.png",
    },
    {
      id: 62,
      name: "Random Real World Map",
      image: "rwm_random_real_world_map.png",
    },
    {
      id: 63,
      name: "Blind Random",
      image: "rm_blind_random.png",
    },
    {
      id: 65,
      name: "Random Special Map",
      image: "",
    },
    {
      id: 66,
      name: "Random Special Map",
      image: "",
    },
    {
      id: 67,
      name: "Acropolis",
      image: "rm_acropolis.png",
    },
    {
      id: 68,
      name: "Budapest",
      image: "rm_budapest.png",
    },
    {
      id: 69,
      name: "Cenotes",
      image: "rm_cenotes.png",
    },
    {
      id: 70,
      name: "City of Lakes",
      image: "rm_city-of-lakes.png",
    },
    {
      id: 71,
      name: "Golden Pit",
      image: "rm_golden-pit.png",
    },
    {
      id: 72,
      name: "Hideout",
      image: "rm_hideout.png",
    },
    {
      id: 73,
      name: "Hill Fort",
      image: "rm_hill-fort.png",
    },
    {
      id: 74,
      name: "Lombardia",
      image: "rm_lombardia.png",
    },
    {
      id: 75,
      name: "Steppe",
      image: "rm_steppe.png",
    },
    {
      id: 76,
      name: "Valley",
      image: "rm_valley.png",
    },
    {
      id: 77,
      name: "Megarandom",
      image: "rm_megarandom.png",
    },
    {
      id: 78,
      name: "Hamburger",
      image: "rm_hamburger.png",
    },
    {
      id: 79,
      name: "Random",
      image: "rm_ctr_random.png",
    },
    {
      id: 80,
      name: "Monsoon",
      image: "rm_ctr_monsoon.png",
    },
    {
      id: 81,
      name: "Pyramid Descent",
      image: "rm_ctr_pyramid-descent.png",
    },
    {
      id: 82,
      name: "Spiral",
      image: "rm_ctr_spiral.png",
    },
    {
      id: 83,
      name: "Kilimanjaro",
      image: "rm_kilimanjaro.png",
    },
    {
      id: 84,
      name: "Mountain Pass",
      image: "rm_mountain-pass.png",
    },
    {
      id: 85,
      name: "Nile Delta",
      image: "rm_nile-delta.png",
    },
    {
      id: 86,
      name: "Serengeti",
      image: "rm_serengeti.png",
    },
    {
      id: 87,
      name: "Socotra",
      image: "rm_socotra.png",
    },
    {
      id: 88,
      name: "Amazon",
      image: "rwm_amazon.png",
    },
    {
      id: 89,
      name: "China",
      image: "rwm_china.png",
    },
    {
      id: 90,
      name: "Horn of Africa",
      image: "rwm_horn_of_africa.png",
    },
    {
      id: 91,
      name: "India",
      image: "rwm_india.png",
    },
    {
      id: 92,
      name: "Madagascar",
      image: "rwm_madagascar.png",
    },
    {
      id: 93,
      name: "West Africa",
      image: "rwm_west_africa.png",
    },
    {
      id: 94,
      name: "Bohemia",
      image: "rwm_bohemia.png",
    },
    {
      id: 95,
      name: "Earth",
      image: "rwm_earth.png",
    },
    {
      id: 96,
      name: "Canyons",
      image: "sm_canyons.png",
    },
    {
      id: 97,
      name: "Enemy Archipelago",
      image: "sm_enemy-archipelago.png",
    },
    {
      id: 98,
      name: "Enemy Islands",
      image: "sm_enemy-islands.png",
    },
    {
      id: 99,
      name: "Far Out",
      image: "sm_far-out.png",
    },
    {
      id: 100,
      name: "Front Line",
      image: "sm_front-line.png",
    },
    {
      id: 101,
      name: "Inner Circle",
      image: "sm_inner-circle.png",
    },
    {
      id: 102,
      name: "Motherland",
      image: "sm_motherland.png",
    },
    {
      id: 103,
      name: "Open Plains",
      image: "sm_open-plains.png",
    },
    {
      id: 104,
      name: "Ring of Water",
      image: "sm_ring-of-water.png",
    },
    {
      id: 105,
      name: "Snake Pit",
      image: "sm_snake-pit.png",
    },
    {
      id: 106,
      name: "The Eye",
      image: "sm_the-eye.png",
    },
    {
      id: 107,
      name: "Australia",
      image: "rwm_australia.png",
    },
    {
      id: 108,
      name: "Indochina",
      image: "rwm_indochina.png",
    },
    {
      id: 109,
      name: "Indonesia",
      image: "rwm_indonesia.png",
    },
    {
      id: 110,
      name: "Strait of Malacca",
      image: "rwm_strait_of_malacca.png",
    },
    {
      id: 111,
      name: "Phillipines",
      image: "rwm_phillipines.png",
    },
    {
      id: 112,
      name: "Bog Islands",
      image: "rm_bog-islands.png",
    },
    {
      id: 113,
      name: "Mangrove Jungle",
      image: "rm_mangrove-jungle.png",
    },
    {
      id: 114,
      name: "Pacific Islands",
      image: "rm_pacific-islands.png",
    },
    {
      id: 115,
      name: "Sandbank",
      image: "rm_sandbank.png",
    },
    {
      id: 116,
      name: "Water Nomad",
      image: "rm_water-nomad.png",
    },
    {
      id: 117,
      name: "Jungle Islands",
      image: "sm_jungle-islands.png",
    },
    {
      id: 118,
      name: "Holy Line",
      image: "sm_holy-line.png",
    },
    {
      id: 119,
      name: "Border Stones",
      image: "sm_border-stones.png",
    },
    {
      id: 120,
      name: "Yin Yang",
      image: "sm_yin-yang.png",
    },
    {
      id: 121,
      name: "Jungle Lanes",
      image: "sm_jungle-lanes.png",
    },
    {
      id: 122,
      name: "Alpine Lakes",
      image: "rm_alpine-lakes.png",
    },
    {
      id: 123,
      name: "Bogland",
      image: "rm_bogland.png",
    },
    {
      id: 124,
      name: "Mountain Ridge",
      image: "rm_mountain-ridge.png",
    },
    {
      id: 125,
      name: "Ravines",
      image: "rm_ravines.png",
    },
    {
      id: 126,
      name: "Wolf Hill",
      image: "rm_wolf-hill.png",
    },
    {
      id: 132,
      name: "Antarctica",
      image: "rwm_antarctica.png",
    },
    {
      id: 137,
      name: "Generic",
      image: "cm_generic.png",
    },
    {
      id: 139,
      name: "Golden Swamp",
      image: "rm_golden-swamp.png",
    },
    {
      id: 140,
      name: "Four Lakes",
      image: "rm_four-lakes.png",
    },
    {
      id: 141,
      name: "Land Nomad",
      image: "rm_land_nomad.png",
    },
    {
      id: 142,
      name: "Battle on the Ice",
      image: "br_battle_on_the_ice.png",
    },
    {
      id: 143,
      name: "El Dorado",
      image: "br_el_dorado.png",
    },
    {
      id: 144,
      name: "Fall of Axum",
      image: "br_fall_of_axum.png",
    },
    {
      id: 145,
      name: "Fall of Rome",
      image: "br_fall_of_rome.png",
    },
    {
      id: 146,
      name: "The Majapahit Empire",
      image: "br_the_majapahit_empire.png",
    },
    {
      id: 147,
      name: "Amazon Tunnels",
      image: "rm_amazon_tunnels.png",
    },
    {
      id: 148,
      name: "Coastal Forest",
      image: "rm_coastal_forest.png",
    },
    {
      id: 149,
      name: "African Clearing",
      image: "rm_african_clearing.png",
    },
    {
      id: 150,
      name: "Atacama",
      image: "rm_atacama.png",
    },
    {
      id: 151,
      name: "Seize the Mountain",
      image: "rm_seize_the_mountain.png",
    },
    {
      id: 152,
      name: "Crater",
      image: "rm_crater.png",
    },
    {
      id: 153,
      name: "Crossroads",
      image: "rm_crossroads.png",
    },
    {
      id: 154,
      name: "Michi",
      image: "rm_michi.png",
    },
    {
      id: 155,
      name: "Team Moats",
      image: "rm_team_moats.png",
    },
    {
      id: 156,
      name: "Volcanic Island",
      image: "rm_volcanic_island.png",
    },
    {
      id: 157,
      name: "Acclivity",
      image: "ew_acclivity.png",
    },
    {
      id: 158,
      name: "Eruption",
      image: "ew_eruption.png",
    },
    {
      id: 159,
      name: "Frigid Lake",
      image: "ew_frigid_lake.png",
    },
    {
      id: 160,
      name: "Greenland",
      image: "ew_greenland.png",
    },
    {
      id: 161,
      name: "Lowland",
      image: "ew_lowland.png",
    },
    {
      id: 162,
      name: "Marketplace",
      image: "ew_marketplace.png",
    },
    {
      id: 163,
      name: "Meadow",
      image: "ew_meadow.png",
    },
    {
      id: 164,
      name: "Mountain Range",
      image: "ew_mountain_range.png",
    },
    {
      id: 165,
      name: "Northern Isles",
      image: "ew_northern_isles.png",
    },
    {
      id: 166,
      name: "Ring Fortress",
      image: "ew_ring_fortress.png",
    },
    {
      id: 167,
      name: "Runestones",
      image: "ew_runestones.png",
    },
    {
      id: 168,
      name: "Aftermath",
      image: "ew_aftermath.png",
    },
    {
      id: 169,
      name: "Enclosed",
      image: "ew_enclosed.png",
    },
    {
      id: 170,
      name: "Haboob",
      image: "ew_haboob.png",
    },
    {
      id: 171,
      name: "Kawasan",
      image: "ew_kawasan.png",
    },
    {
      id: 172,
      name: "Land Madness",
      image: "ew_land-madness.png",
    },
    {
      id: 173,
      name: "Sacred Springs",
      image: "ew_sacred-springs.png",
    },
    {
      id: 174,
      name: "Wade",
      image: "ew_wade.png",
    },
  ],
};

export default MapData;
